(($) => {
    $(document).ready(() => {

        $('body').on('click', 'button[name="tinvwl-remove"]', function () {
            $(this).closest('tr.wishlist_item')
                .addClass('tinvwl-pending-delete');
            let intervalFunc = function () {
                if ((!$('.tinv-modal-inner > .icon_big_heart_check').length) && (!$('.tinv-modal-inner > .icon_big_times').length)) {
                    window.setTimeout(intervalFunc, 500);
                    return;
                }

                if ($('.tinv-modal-inner > .icon_big_heart_check').length) {
                    $('.tinvwl-pending-delete').remove();
                } else {
                    $('.tinvwl-pending-delete').removeClass('tinvwl-pending-delete');
                }
            };

            window.setTimeout(intervalFunc, 500);
        });

        $('.billing-company-ac input').each(function () {
            $('<small class="dutch-notice">').html('Vul in en selecteer jouw bedrijfsnaam in de dropdown, dan worden de juiste KvK gegevens aan jouw account gekoppeld.')
                .insertAfter($(this));
        });

        if ($('#billing_country').length) {
            $('#billing_country').change(function () {
                $('#coc_number_field').removeClass('hidden');
                $('#coc_number_field').find('input').attr('required');

                if ($('.woocommerce-checkout [name="entity_type"]').length) {
                    $('[name="entity_type"]').trigger('change');
                }
            });

            $('#billing_country').trigger('change');
        }

        if ($('#billing_postcode').length) {
            $(document).bind("click focuslost", function () {
                let value = $('#billing_postcode').val();
                if (value) {
                    value = value.replaceAll(" ", "");
                    value = value.substring(0, 4) + " " + value.substring(4, value.length);
                    $('#billing_postcode').val(value);
                }
            })
        }

        if ($('#billing_postcode').length) {
            $('#billing_postcode').change(function () {
                let value = $('#billing_postcode').val();
                if (value) {
                    value = value.replaceAll(" ", "");
                    value = value.substring(0, 4) + " " + value.substring(4, value.length);
                    $('#billing_postcode').val(value);
                }
            });
        }

        $("body").on('click', '.pin-btn', function () {
            if (!$(this).data('origurl')) {
                $(this).data('origurl', $(this).attr('href'));
            }

            $(this).attr('href', $(this).data('origurl') + encodeURIComponent($('.owl-item.active').find('img').attr('src')));
        });


        $('.woocommerce-checkout #billing_company_field, .woocommerce-checkout #coc_number_field').each(function () {

            var select = $('[name="entity_type"]');
            $(this).find('.optional').replaceWith($('abbr.required').first().clone());

            var reflect = () => {
                let forceHidden = false;

                if (select.closest('.collection-book-application').length) {
                    $('.woocommerce-account-fields').addClass('hidden')
                        .find('[name="createaccount"]')
                        .prop('checked', false)
                        .val('')
                        .trigger('change');
                } else {
                    if (forceHidden || (select.length && ((!select.val()) || select.val() === 'Particulier' || select.val() === 'Student' || select.val() === 'Zakelijke eindklant'))) {

                        $(this).addClass('hidden');
                        $(this).find('input').removeAttr('required')
                            .val('')
                            .trigger('change');

                        $('.woocommerce-account-fields').addClass('hidden')
                            .find('[name="createaccount"]')
                            .prop('checked', false)
                            .trigger('change');
                    } else {
                        $(this).removeClass('hidden');
                        $('.woocommerce-account-fields').removeClass('hidden')
                            .find('[name="createaccount"]')
                            .prop('checked', true)
                            .trigger('change');
                        $(this).find('input').attr('required');
                    }

                }
            };

            select.change(reflect)
                .trigger('change');
            reflect.apply(this);
        });

        $(document).on('submit', 'form.atc-form', function () {
            var contents = [];
            $('select[data-sku]').filter(function () {
                return parseInt($(this).val());
            })
                .each(function () {
                    contents.push($(this).data('sku'));
                });

            fbq('track', 'AddToCart', {
                content_ids: contents,
                content_type: 'product',
            });
        });
    });
})(jQuery);
